import { render, staticRenderFns } from "./JdsBreakdownItem.vue?vue&type=template&id=7df45e8b&scoped=true&"
import script from "./JdsBreakdownItem.vue?vue&type=script&lang=ts&"
export * from "./JdsBreakdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./JdsBreakdownItem.vue?vue&type=style&index=0&id=7df45e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df45e8b",
  null
  
)

export default component.exports